var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D90429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.054 8.437a1.02 1.02 0 01-.24-.69c0-.25.11-.49.29-.67.18-.18.42-.28.67-.29.25 0 .5.08.69.24l3.36 3.36s.05.04.08.06c.03.01.06.02.1.02.04 0 .07 0 .1-.02.03-.01.06-.03.08-.06l3.36-3.36c.19-.19.44-.31.71-.31.27 0 .53.1.72.28.19.19.31.44.31.71 0 .27-.1.53-.28.72l-3.36 3.36s-.04.05-.06.08c-.01.03-.02.06-.02.1 0 .04 0 .07.02.1.01.03.03.06.06.08l3.36 3.36c.1.09.18.21.23.33.05.13.08.26.08.4s-.03.27-.08.4-.13.24-.23.33c-.09.09-.2.17-.33.22a.83.83 0 01-.38.07c-.26 0-.51-.11-.7-.29l-3.36-3.36s-.05-.04-.08-.06a.296.296 0 00-.1-.02c-.04 0-.07 0-.1.02-.03.01-.06.03-.08.06l-3.41 3.36c-.19.18-.44.29-.7.29a.986.986 0 01-1-.99c0-.26.1-.52.29-.7l3.36-3.36s.04-.05.06-.08c.01-.03.02-.06.02-.1 0-.04 0-.07-.02-.1a.156.156 0 00-.06-.08l-3.36-3.41z",
    fill: "#fff"
  })));
}
export default SvgIconErrorCircle24;